import React, { Component } from 'react';
import { Col, Row, ListGroup, ListGroupItem, Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import { SvgAssets } from '../../assets/icons/iconSvg';
import Pagination from '../reusable/Pagination'
import { getAlertas } from '../../store/sagas/alertaApi';
import localStorageCustom from '../../utilitarios/localStorage';
import { notificacion, getStatePage } from '../../utilitarios/util';
import { data } from '../../constants/Constants';
import c from '../../constants/Colors';
import { AuthContext } from "../../store/provider/AuthProvider";
import Spinner from "../reusable/Loader";

export class Notificaciones extends Component {
  static displayName = Notificaciones.name;
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      page: 1,
      size: data.PageSize,
      currentPage: 1,
      dealer: {},
      linea: {},
      asociado: {},
      alertas: [],
      topalertas: []
    };
  }

  load = (dealerAlertas, setdealerAlertas) => {
    let result = localStorageCustom.prototype.getUsuario();
    this.setState({ page: 1, loading: true, dealer: result.dealer, linea: result.linea, asociado: result.asociado }, () => {
      this.postAlertas(result.dealer, result.linea, result.asociado, this.state.page, setdealerAlertas);
    })
  }
  componentDidMount() {
    if (getStatePage(this.props)) {
      window.scrollTo(0, 0)
      const auth = this.context;
      this.load(auth.dealerAlertas, auth.setdealerAlertas);
    } else
      window.location.href = "/";
  }

  render() {
    const { loading, alertas, topalertas, page, size, currentPage, } = this.state;
    const auth = this.context;
    return (
      <div id="mhw">
        <Spinner visible={loading} />
        <div className="desktop">
          <div className="title_banner">
            <Container>
              <h1><SvgAssets icon="icon-campana" fill="#fff" />Notificaciones</h1>
            </Container>
            <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
          </div>
          <div className="breadcrumb">
            <Container>
              <ul>
                <li><Link to='/dashboard'>Dashboard</Link></li>
                <li>Notificaciones</li>
              </ul>
            </Container>
          </div>
        </div>
        <Container className="py-5 container_1080">
          <h6 className="title white mobile"><SvgAssets icon="icon-campana" fill="#fff" />Notificaciones</h6>
          <h4 className="desktop_parrafo2 text-right desktop mb-2" style={{ color: c.grisMedio }}>
            <SvgAssets icon="icon-reloj" fill={c.grisMedio} />
            Últimos &nbsp;<strong style={{ color: c.azulClaro }}>10 días</strong>
          </h4>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill={'#1B52B2'} />
            <h4 className="title-5 gris-1 mobile"><SvgAssets icon="icon-reloj" fill={c.grisClaro} />Últimos &nbsp;<strong style={{ color: c.celeste }}>10 días</strong></h4>
            <ListGroup flush className="container_840">
              <ListGroupItem>
                <Row form>
                  <Col xs={1} md={1}>
                    <span className='paragraph-3 bold' style={{ color: '#7371FF' }}>#</span>
                  </Col>
                  <Col xs={8} md={9}>
                    <span className='paragraph-3 bold' style={{ color: c.azulClaro }}>Detalle</span>
                  </Col>
                  <Col xs={3} md={2}>
                    <span className='paragraph-3 bold' style={{ color: '#2DB997' }}>Fecha</span>
                  </Col>
                </Row>
              </ListGroupItem>
              {alertas.map((alerta, index) => {
                return (
                  <ListGroupItem key={index}>
                    <Row form>
                      <Col xs={1} md={1}><span className='paragraph-3 desktop_parrafo2 bold' style={{ color: '#7371FF' }}>{alerta.nro}</span></Col>
                      <Col xs={8} md={9}><span className='paragraph-2 light' style={{ color: '#316ACD' }}>{alerta.mensaje}.</span></Col>
                      <Col xs={3} md={2}>
                        {(alerta.fechaHace == null) ?
                          <span className='paragraph-3 desktop_parrafo3 light' style={{ color: '#2DB997' }}>
                            <strong className="d-block desktop_parrafo2">{alerta.fecha}</strong>{alerta.hora}
                          </span>
                          :
                          <span className='paragraph-3 desktop_parrafo2 bold' style={{ color: '#2DB997' }}>
                            {alerta.fechaHace}
                          </span>
                        }
                      </Col>
                    </Row>
                  </ListGroupItem>
                )
              })}
              {/* <ListGroupItem>
                <Row form>
                  <Col xs={1}><span className='paragraph-3 bold' style={{ color: '#7371FF' }}>01</span></Col>
                  <Col xs={8}><span className='paragraph-2' style={{ color: '#316ACD' }}>El pedido N° 9999999999,vence en 5 horas.</span></Col>
                  <Col xs={3}><span className='paragraph-3 bold' style={{ color: '#2DB997' }}><strong className="d-block">01 / 09 /20</strong>9:00 am</span></Col>
                </Row>
              </ListGroupItem> */}
              {/* <ListGroupItem>
                <Row form>
                  <Col xs={1}><span className='paragraph-3 bold' style={{ color: '#7371FF' }}>02</span></Col>
                  <Col xs={8}><span className='paragraph-2' style={{ color: '#316ACD' }}>
                    Actualice su contraseña, recuerda que tu actual contraseña vence en 3 días.</span></Col>
                  <Col xs={3}><span className='paragraph-3 bold' style={{ color: '#2DB997' }}><strong className="d-block">30 / 08 /20</strong>9:00 am</span></Col>
                </Row>
              </ListGroupItem> */}
            </ListGroup>
            {(alertas.length > 0) ? <Pagination event={this.setPage} current={page} currentPage={currentPage} totalPage={alertas[0].totalPage} size={size} /> : null}
            <div className="text-center mt-4 mobile">
              <Link to="/dashboard" style={{ textDecoration: 'none' }}>
                <button className='btn-block'>salir</button>
              </Link>
            </div>
          </div>
          <div className="text-center mt-5 desktop">
            <Link to="/dashboard" style={{ textDecoration: 'none' }}>
              <button className='btn-block'>salir</button>
            </Link>
          </div>
        </Container>
      </div>
    );
  }
  postAlertas = async (dealer, linea, asociado, page, setdealerAlertas) => {
    getAlertas(dealer.codcliente, dealer.correoElectronico, linea,  asociado.poblacion, page)
      .then(result => {
        if (result.mo.type == "success") {
          if (this.state.topalertas.length == 0) {
            let top = [];
            console.log("setdealerAlertas==>", setdealerAlertas);
            if (setdealerAlertas != undefined)
              setdealerAlertas(top);
            this.setState({
              loading: false,
              alertas: result.dto.alertas,
              topalertas: top
            })
          } else {
            this.setState({
              loading: false,
              alertas: result.dto.alertas,
            })
          }
        } else {
          throw new Error(result.mo.listMessage.join(", "));
        }
      }).catch((error) => {
        this.setState({ loading: false }, async () => {
          error.message = (error.message == undefined || error.message == null) ? error.description : error.message;
          await notificacion("Buscador", error.message ?? null);
        });
      });
  }
  setPage = (index, change, type) => {
    const auth = this.context;
    if (change) {
      let _currentPage = this.state.currentPage
      this.setState({ loading: true, page: index, currentPage: type == "add" ? (_currentPage + 1) : (_currentPage - 1) })
    }
    else
      this.setState({ page: index, loading: true })

    // this.setState({  loading: false })
    this.postAlertas(this.state.dealer, this.state.linea, this.state.asociado, index);
  }
}
